import { render } from "./TipTapVr.vue?vue&type=template&id=98213542"
import script from "./TipTapVr.vue?vue&type=script&lang=js"
export * from "./TipTapVr.vue?vue&type=script&lang=js"

import "./TipTapVr.vue?vue&type=style&index=0&id=98213542&lang=scss"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__